import { createSlice } from "@reduxjs/toolkit";
import { getNotice } from "./thunk";

export interface IState {
  Notice: any;
  isNoticeLoading: boolean;
  isNoticeSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  Notice: null,
  isNoticeLoading: false,
  isNoticeSuccess: false,

  error: {},
};

const NoticeSlice = createSlice({
  name: "Notice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Notice
    builder.addCase(getNotice.pending, (state: IState, action: any) => {
      state.isNoticeLoading = true;
    });
    builder.addCase(getNotice.fulfilled, (state: IState, action: any) => {
      state.Notice = action.payload?.data;
      state.isNoticeSuccess = true;
      state.isNoticeLoading = false;
    });
    builder.addCase(getNotice.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isNoticeSuccess = false;
      state.isNoticeLoading = false;
    });
  },
});

export default NoticeSlice.reducer;
